import { HttpClient } from '@angular/common/http';
import { Base } from './base';
import { TokenBalances } from './accounts/token-balances';
import { PositionUpdates } from './accounts/position-updates';
import { Funds } from './accounts/funds';

export class Accounts extends Base {
  constructor(protected httpClient: HttpClient) {
    super(httpClient, 'accounts');
  }

  of(id: string) {
    id = id.toLowerCase();
    return {
      tokenBalances: new TokenBalances(this.httpClient, this.pathJoin(id)),
      positionUpdates: new PositionUpdates(this.httpClient, this.pathJoin(id)),
      funds: new Funds(this.httpClient, this.pathJoin(id))
    };
  }
}
